export default {
  message: () => 'Geef een geldig ondernemingsnummer in.',
  validate: (value) => {
    if (!value) return true;
    const trimmedOndernemingsnummer = value.replace(/\.|-|\s/g, '');
    const regex = new RegExp('^[0-9]{9,10}$');
    return regex.test(trimmedOndernemingsnummer);
  }
};
